var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
var ShareWidget = /** @class */ (function (_super) {
    __extends(ShareWidget, _super);
    function ShareWidget(props) {
        var _this = _super.call(this, props) || this;
        _this._isMounted = false;
        _this.state = {
            shareWidgetData: [],
            showText: "Show",
            hideText: "Hide",
            isMobile: true
        };
        _this.onComponentResize = _this.onComponentResize.bind(_this);
        return _this;
    }
    ShareWidget.prototype.onComponentResize = function () {
        var mobileBreakpoint = 767; // max
        var smallerThanMobileBreakpoint = document.documentElement.clientWidth <= mobileBreakpoint ? true : false;
        this.setState({
            isMobile: smallerThanMobileBreakpoint,
        });
    };
    ShareWidget.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var delayResizeEvent, SnippetHelper, widgetData, facebookLabel, twitterLabel, linkedInLabel, printLabel, emailLabel, showLabel, hideLabel;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        window.addEventListener('resize', function () {
                            clearTimeout(delayResizeEvent);
                            delayResizeEvent = setTimeout(_this.onComponentResize, 100);
                        });
                        // we call onComponentResize() initially when the component first loads, after waiting a few seconds for the rest of the page to load
                        setTimeout(this.onComponentResize, 5000);
                        return [4 /*yield*/, import(
                            /* webpackChunkName: 'helpers' */
                            '@pm-tt/common-components/lib/SnippetHelper')];
                    case 1:
                        SnippetHelper = (_a.sent()).SnippetHelper;
                        this._isMounted = true;
                        widgetData = [];
                        return [4 /*yield*/, SnippetHelper.getSnippet("#shareFacebookLabel")];
                    case 2:
                        facebookLabel = _a.sent();
                        if (facebookLabel.length > 0 && this._isMounted) {
                            widgetData.push({
                                "FacebookText": facebookLabel[0].snippet
                            });
                        }
                        return [4 /*yield*/, SnippetHelper.getSnippet("#shareTwitterLabel")];
                    case 3:
                        twitterLabel = _a.sent();
                        if (twitterLabel.length > 0 && this._isMounted) {
                            widgetData.push({
                                "TwitterText": twitterLabel[0].snippet
                            });
                        }
                        return [4 /*yield*/, SnippetHelper.getSnippet("#shareLinkedInLabel")];
                    case 4:
                        linkedInLabel = _a.sent();
                        if (linkedInLabel.length > 0 && this._isMounted) {
                            widgetData.push({
                                "LinkedInText": linkedInLabel[0].snippet
                            });
                        }
                        return [4 /*yield*/, SnippetHelper.getSnippet("#sharePrintLabel")];
                    case 5:
                        printLabel = _a.sent();
                        if (printLabel.length > 0 && this._isMounted) {
                            widgetData.push({
                                "PrintText": printLabel[0].snippet
                            });
                        }
                        return [4 /*yield*/, SnippetHelper.getSnippet("#shareEmailLabel")];
                    case 6:
                        emailLabel = _a.sent();
                        if (emailLabel.length > 0 && this._isMounted) {
                            widgetData.push({
                                "EmailText": emailLabel[0].snippet
                            });
                        }
                        return [4 /*yield*/, SnippetHelper.getSnippet("#show")];
                    case 7:
                        showLabel = _a.sent();
                        if (showLabel.length > 0 && this._isMounted) {
                            this.setState({
                                showText: showLabel[0].snippet
                            });
                        }
                        return [4 /*yield*/, SnippetHelper.getSnippet("#hide")];
                    case 8:
                        hideLabel = _a.sent();
                        if (hideLabel.length > 0 && this._isMounted) {
                            this.setState({
                                hideText: hideLabel[0].snippet
                            });
                        }
                        this.setState({
                            shareWidgetData: widgetData
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ShareWidget.prototype.componentWillUnmount = function () {
        var _this = this;
        // remove the resize listener when this component is unmounted
        window.removeEventListener('resize', function () {
            _this.onComponentResize();
        });
    };
    ShareWidget.prototype.render = function () {
        var _this = this;
        var renderItems = null;
        if (this.state.shareWidgetData.length > 0) {
            renderItems = this.state.shareWidgetData.map(function (item, index) {
                if (item["FacebookText"]) {
                    return (React.createElement("li", { key: "shareWidget" + index },
                        React.createElement("a", { href: "https://www.facebook.com/sharer/sharer.php?u=" + window.location.href, target: "_blank", title: item["FacebookText"] },
                            React.createElement("i", { className: "fab fa-facebook-f fa-2x" }))));
                }
                if (item["TwitterText"]) {
                    return (React.createElement("li", { key: "shareWidget" + index },
                        React.createElement("a", { href: "http://twitter.com/intent/tweet?text=" + document.title + "&url=" + window.location.href, target: "_blank", title: item["TwitterText"] },
                            React.createElement("i", { className: "fab fa-twitter fa-2x" }))));
                }
                if (item["LinkedInText"]) {
                    return (React.createElement("li", { key: "shareWidget" + index },
                        React.createElement("a", { href: "http://www.linkedin.com/shareArticle?mini=true&title=" + document.title + "&url=" + window.location.href, target: "_blank", title: item["LinkedInText"] },
                            React.createElement("i", { className: "fab fa-linkedin-in fa-2x" }))));
                }
                if (item["PrintText"]) {
                    return (React.createElement("li", { key: "shareWidget" + index },
                        React.createElement("button", { onClick: function (e) { return _this.print(e); }, title: item["PrintText"] },
                            React.createElement("i", { className: "fas fa-print fa-2x" }))));
                }
                if (item["EmailText"]) {
                    return (React.createElement("li", { key: "shareWidget" + index },
                        React.createElement("button", { onClick: function (e) { return _this.email(e, document.title, window.location.href); }, title: item["EmailText"] },
                            React.createElement("i", { className: "fas fa-envelope fa-2x" }))));
                }
            });
        }
        var accordionStyle = { display: 'none' };
        return (React.createElement("div", { id: "shareLinks" },
            !this.state.isMobile && (React.createElement("button", { ref: "shareAccordionBtn", onClick: function (e) { _this.showHideWidget(e); }, className: "shareWidgetBtn", key: "shareAccordion" },
                React.createElement("i", { ref: "shareAccordionIcon", className: "fas fa-angle-up fa-2x" }),
                React.createElement("span", { ref: "shareWidgetBtnText", id: "btnText" }, this.state.showText))),
            !this.state.isMobile && (React.createElement("ul", { id: "shareAccordionItems", style: accordionStyle }, renderItems))));
    };
    ShareWidget.prototype.showHideWidget = function (e) {
        e.preventDefault();
        e.stopPropagation();
        var accordionItems = document.getElementById("shareAccordionItems");
        if (accordionItems.style.display === "none") {
            accordionItems.style.display = "block";
            var iconElement = this.refs["shareAccordionIcon"];
            iconElement.className = "fas fa-angle-down fa-2x";
            var btnText = this.refs["shareWidgetBtnText"];
            btnText.innerHTML = this.state.hideText;
        }
        else {
            accordionItems.style.display = "none";
            var iconElement = this.refs["shareAccordionIcon"];
            iconElement.className = "fas fa-angle-up fa-2x";
            var btnText = this.refs["shareWidgetBtnText"];
            btnText.innerHTML = this.state.showText;
        }
    };
    ShareWidget.prototype.print = function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.print();
    };
    ShareWidget.prototype.email = function (e, title, url) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = "mailto:?subject=" + title + "&body=" + url;
    };
    return ShareWidget;
}(React.Component));
export { ShareWidget };
